__turbopack_context__.v({
  "carouselContainer": "_8RCE1G_carouselContainer",
  "headerRow": "_8RCE1G_headerRow",
  "imgContainer": "_8RCE1G_imgContainer",
  "link": "_8RCE1G_link",
  "scrollableRowContainer": "_8RCE1G_scrollableRowContainer",
  "text": "_8RCE1G_text",
  "textContainer": "_8RCE1G_textContainer",
});
